import React, { useState, useEffect } from "react";

const Sidebar = () => {
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [reasearchDataDropdown, setReasearchDataDropdown] = useState(false);
  const [radcliffReportDropdown, setRadcliffReportDropdown] = useState(false);
  const [speechReportDropdown, setSpeechReportDropdown] = useState(false);
  const [myStudiesDropdown, setMyStudiesDropdown] = useState(false);
console.log("sites----->",localStorage.getItem("sites"));
console.log("isSitemanager----->",localStorage.getItem("is_site_manager"));
localStorage.getItem(
  "consortia_company_member_name"
);
console.log("consortia_company_member_name----->",localStorage.getItem(
  "consortia_company_member_name"
));
  // menu toggle
  const toggle = (param) => {
    if (param == "1") {
      setToggleDropdown(!toggleDropdown);
    } else if (param == "research_data") {
      setReasearchDataDropdown(!reasearchDataDropdown);
    } else if (param == "radcliff_report") {
      setRadcliffReportDropdown(!radcliffReportDropdown);
    } else if (param == "speech_report") {
      setSpeechReportDropdown(!speechReportDropdown);
    } else if (param === "my_studies") {
      setMyStudiesDropdown(!myStudiesDropdown);
    }
  };

  // if dropdown is selected
  useEffect(() => {
    if (
      window.location.pathname == "/speech-study" ||
      window.location.pathname == "/radcliff-study" ||
      window.location.pathname == "/ecas" ||
      window.location.pathname == "/ecas/list" ||
      window.location.pathname == "/ecas-view" ||
      window.location.pathname == "/slp-substudy" ||
      window.location.pathname === "/participants/speech" ||
      window.location.pathname === "/participants/radcliff" ||
      window.location.pathname === "/view-demographics" ||
      window.location.pathname === "/participant/view-demographics"
    ) {
      setReasearchDataDropdown(true);
    }
  }, []);

  useEffect(() => {
    if (
      window.location.pathname === "#" ||
      window.location.pathname === "/participant-status" ||
      window.location.pathname === "/mystudies/dashboard" ||
      window.location.pathname === "/mystudies/reports" ||
      window.location.pathname === "/mystudies/resources"
    ) {
      setMyStudiesDropdown(true);
    }
  }, []);

  return (
    <div className="sidebar-section" id="sidebar">
      <ul>
      {localStorage.getItem("is_site_manager") == "no" || null ? (
  <>
    <li
      className={window.location.pathname === "/dashboard" ? "active" : ""}
      style={{ position: "relative" }}
    >
      <a href="/dashboard">
        <i className="fas fa-chart-line"></i>
        <span className="m-2">Dashboard</span>
      </a>
    </li>
    <li
      onClick={() => toggle("research_data")}
      className={
        [
          "/speech-study",
          "/radcliff-study",
          "/ecas",
          "/ecas/list",
          "/ecas-view",
          "/slp-substudy",
          "/participants/speech",
          "/participants/radcliff",
          "/view-demographics",
          "/participant/view-demographics",
        ].includes(window.location.pathname)
          ? "active"
          : ""
      }
      style={{ position: "relative" }}
    >
      <a href="#!">
        <i className="fas fa-search" style={{ marginRight: 13 }}></i>
        <span>Research Data</span>
        {reasearchDataDropdown ? (
          <i
            className="fas fa-chevron-up"
            style={{
              fontSize: 14,
              position: "absolute",
              right: 18,
              top: 19,
            }}
          ></i>
        ) : (
          <i
            className="fas fa-chevron-down"
            style={{
              fontSize: 14,
              position: "absolute",
              right: 18,
              top: 19,
            }}
          ></i>
        )}
      </a>
    </li>
    <div
      className={
        reasearchDataDropdown
          ? "sidebar-dropdown active-dropdwon"
          : "sidebar-dropdown"
      }
    >
      <ul style={{ overflowY: "visible" }}>
        <li
          className={
            [
              "/speech-study",
              "/participants/speech",
              "/view-demographics",
            ].includes(window.location.pathname)
              ? "active"
              : ""
          }
          style={{ paddingLeft: 68 }}
        >
          <a
            href="/participants/speech"
            style={{
              fontSize: "15",
              fontFamily: "Open Sans",
              fontWeight: "regular",
              color: "#1A4F83",
            }}
          >
            <span>AUSTEN SPEECH Study</span>
          </a>
        </li>
        <li
          className={
            [
              "/radcliff-study",
              "/participants/radcliff",
              "/participant/view-demographics",
            ].includes(window.location.pathname)
              ? "active"
              : ""
          }
          style={{ paddingLeft: 68 }}
        >
          <a
            href="/participants/radcliff"
            style={{
              fontSize: "15",
              fontFamily: "Open Sans",
              fontWeight: "regular",
              color: "#1A4F83",
            }}
          >
            <span>RADCLIFF Study</span>
          </a>
        </li>
        <li
          className={
            ["/ecas", "/ecas/list", "/ecas-view"].includes(
              window.location.pathname
            )
              ? "active"
              : ""
          }
          style={{ paddingLeft: 68 }}
        >
          <a
            href="/ecas/list"
            style={{
              fontSize: "15",
              fontFamily: "Open Sans",
              fontWeight: "regular",
              color: "#1A4F83",
            }}
          >
            <span>ECAS</span>
          </a>
        </li>
      </ul>
    </div>
    <>
    </>
  </>
) : null}

{localStorage.getItem("is_site_manager") == "yes" || localStorage.getItem("provide_study_dashboard_access")=="yes" ?(<><li
        onClick={() => toggle("my_studies")}
        className={
          [
            "/mystudies/dashboard",
            "/participant-status",
            "/mystudies/dashboard",
            "/mystudies/reports",
            "/mystudies/resources",
          ].includes(window.location.pathname)
            ? "active"
            : ""
        }
        style={{ position: "relative" }}
      >
        <a href="#!">
          <i className="fas fa-book" style={{ marginRight: 18 }}></i>
          <span>My Studies</span>
          {myStudiesDropdown ? (
            <i
              className="fas fa-chevron-up"
              style={{
                fontSize: 14,
                position: "absolute",
                right: 18,
                top: 19,
              }}
            ></i>
          ) : (
            <i
              className="fas fa-chevron-down"
              style={{
                fontSize: 14,
                position: "absolute",
                right: 18,
                top: 19,
              }}
            ></i>
          )}
        </a>
      </li>
      <div
        className={
          myStudiesDropdown
            ? "sidebar-dropdown active-dropdwon"
            : "sidebar-dropdown"
        }
      >
        <ul style={{ overflowY: "visible" }}>
          <li
            className={
              window.location.pathname === "/mystudies/dashboard"
                ? "active"
                : ""
            }
            style={{ paddingLeft: 68 }}
          >
            <a
              href="/mystudies/dashboard"
              style={{
                fontSize: "15",
                fontFamily: "Open Sans",
                fontWeight: "regular",
                color: "#1A4F83",
                textAlign: "left",
                display: "block",
              }}
            >
              <span>Dashboard</span>
            </a>
          </li>
          <li
            className={
              window.location.pathname === "/participant-status"
                ? "active"
                : ""
            }
            style={{ paddingLeft: 68 }}
          >
            <a
              href="/participant-status"
              style={{
                fontSize: "15",
                fontFamily: "Open Sans",
                fontWeight: "regular",
                color: "#1A4F83",
                textAlign: "left",
                display: "block",
              }}
            >
              <span>Participant Status</span>
            </a>
          </li>
          <li
            className={
              window.location.pathname === "/mystudies/reports"
                ? "active"
                : ""
            }
            style={{ paddingLeft: 68 }}
          >
            <a
              href="/mystudies/reports"
              style={{
                fontSize: "15",
                fontFamily: "Open Sans",
                fontWeight: "regular",
                color: "#1A4F83",
                textAlign: "left",
                display: "block",
              }}
            >
              <span>Reports</span>
            </a>
          </li>
          <li
            className={
              window.location.pathname === "/mystudies/resources"
                ? "active"
                : ""
            }
            style={{ paddingLeft: 68 }}
          >
            <a
              href="/mystudies/resources"
              style={{
                fontSize: "15",
                fontFamily: "Open Sans",
                fontWeight: "regular",
                color: "#1A4F83",
                textAlign: "left",
                display: "block",
              }}
            >
              <span>Resources</span>
            </a>
          </li>
        </ul>
      </div></>):null}


        {localStorage.getItem("is_site_manager") == "no" ?(<>
          <li
          className={window.location.pathname === "/content-library" ? "active" : ""}
          style={{ position: "relative" }}
        >
          <a href="/content-library">
            <i className="fas fa-server"></i>
            <span className="m-2">Content Library</span>
          </a>
        </li>
        <li
          className={window.location.pathname === "/consortia-requests" ? "active" : ""}
          style={{ position: "relative" }}
        >
          <a href="/consortia-requests">
            <i className="fas fa-road"></i>
            <span className="m-2">Consortia Requests</span>
          </a>
        </li>
        <li
          className={window.location.pathname === "/consortia-uploads" ? "active" : ""}
          style={{ position: "relative" }}
        >
          <a href="/consortia-uploads">
            <i className="fas fa-road"></i>
            <span className="m-2">Consortia Uploads</span>
          </a>
        </li>
        <li
          className={window.location.pathname === "/consortia-workspace" ? "active" : ""}
          style={{ position: "relative" }}
        >
          <a href="/consortia-workspace">
            <i className="fas fa-book" style={{ marginRight: 18 }}></i>
            <span>
              Consortia
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Workspace
            </span>
          </a>
        </li>
        <li
          className={window.location.pathname === "/other-data-sources" ? "active" : ""}
          style={{ position: "relative" }}
        >
          <a href="/other-data-sources">
            <i className="fas fa-database"></i>
            <span className="m-2">Data Sources</span>
          </a>
        </li>

        </>):null}
      </ul>
    </div>
  );
};

export default Sidebar;
